import { Component, OnInit, inject } from '@angular/core';
import { TableConfig } from 'src/app/shared/components/app-table/app-table-models';
import { StartService, StandardNameUpdateRecordDTO } from './start.service';
import { StandardNameUpdateStateService  } from './standard-name-update-state.service';

type UiUpdateStatus = 'PENDING' | 'SCHEDULED'| 'FAILED';

interface StandardNameUpdateUi {
  newName: string;
  oldName: string;
  status: UiUpdateStatus;
}

export interface Statistics {
  total: number;
  totalNegative: number;
  today: {
    [labCode: string]: { num: number; numNew: number };
  };
}

@Component({
    selector: 'app-start',
    templateUrl: './startsida.component.html',
    styleUrls: ['./startsida.component.scss'],
    standalone: false
})
export class StartsidaComponent implements OnInit {
  private startService = inject(StartService);
  protected total!: number;
  protected totalNegative!: number;
  protected percentageNegative!: string;
  protected todayTotal!: number;
  protected todayNew!: number;
  protected todayDate = new Date();
  protected standardNameUpdates: StandardNameUpdateUi[] = [];
  private updateState = inject(StandardNameUpdateStateService);

  protected tableConfig: TableConfig = {
    columns: [
      { field: 'labCode', header: 'Laboratorium' },
      { field: 'total', header: 'Totalt prover' },
      { field: 'new', header: 'Nya prover' },
    ],
  };
  get hasStandardNameUpdates(): boolean {
    return this.standardNameUpdates?.length > 0;
  }

  private filterActiveStandardNameUpdates(
    updates: StandardNameUpdateRecordDTO[]
  ): StandardNameUpdateRecordDTO[] {
    return updates?.filter(update => !this.isUpdateDone(update)) ?? [];
  }

  private isUpdateDone(update: StandardNameUpdateRecordDTO): boolean {
    return (
      update.mellanlagerUpdates === 'DONE' &&
      update.lTLUpdates === 'DONE' &&
      update.grunddataUpdates === 'DONE'
    );
  }

  private deriveUiStatus(update: StandardNameUpdateRecordDTO ): UiUpdateStatus | null {

    const statuses = [
      update.mellanlagerUpdates,
      update.lTLUpdates,
      update.grunddataUpdates,
    ];
    if (statuses.some(s => s === 'FAILED')) {
      return 'FAILED';
    }
    if (statuses.some(s => s === 'PENDING')) {
      return 'PENDING';
    }
    if (statuses.some(s => s === 'SCHEDULED')) {
      return 'SCHEDULED';
    }

    return null; // fully DONE → do not display
  }

  ngOnInit() {
    this.startService.getStandardNameUpdates()
      .subscribe((updates: StandardNameUpdateRecordDTO[]) => {
        const activeUpdates = this.filterActiveStandardNameUpdates(updates);
        this.standardNameUpdates = activeUpdates
          .map(update => {
            const status = this.deriveUiStatus(update);
            return status ? { oldName: update.oldName,newName: update.newName, status } : null;
          })
          .filter((u): u is StandardNameUpdateUi => u !== null);
          this.updateState.initFromBackend(updates);
      });

    this.startService.getStatistics().subscribe((statistics: Statistics) => {
      this.total = statistics.total;
      this.totalNegative = statistics.totalNegative;
      this.percentageNegative =( statistics.totalNegative / statistics.total * 100).toFixed(0) + '%';

      const labNumbers = Object.values(statistics.today);

      this.todayTotal = labNumbers?.map((x) => x.num).reduce((a, b) => a + b, 0);
      this.todayNew = labNumbers?.map((x) => x.numNew).reduce((a, b) => a + b, 0);

      const rowData = [];

      for (const [key, value] of Object.entries(statistics.today)) {
        rowData.push({ labCode: key, total: value.num, new: value.numNew });
      }
      this.tableConfig.rows = rowData;
    });

  }
}
